var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.583 3.354 26.646.417 15 12.063 3.354.417.417 3.354 12.063 15 .417 26.646l2.937 2.938L15 17.938l11.646 11.646 2.937-2.938L17.938 15z"
  })));
};
export { SvgX as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI5LjU4MzQgMy4zNTQ0OUwyNi42NDU5IDAuNDE2OTkyTDE1LjAwMDEgMTIuMDYyOEwzLjM1NDI1IDAuNDE2OTkyTDAuNDE2NzQ4IDMuMzU0NDlMMTIuMDYyNiAxNS4wMDAzTDAuNDE2NzQ4IDI2LjY0NjJMMy4zNTQyNSAyOS41ODM3TDE1LjAwMDEgMTcuOTM3OEwyNi42NDU5IDI5LjU4MzdMMjkuNTgzNCAyNi42NDYyTDE3LjkzNzYgMTUuMDAwM0wyOS41ODM0IDMuMzU0NDlaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";